export const GRID_MARGINS = 48;
export const MAX_SPACING = 300;
